"use client";

import { sendEvent } from "@dash0/sdk-web";
import Image from "next/image";
import Link from "next/link";
import { captureEvent } from "@/helpers/analytics";
import type { ImageRef } from "@/lib/content/schemas/primitives";

const CONTENT_CTA_CLICKED_EVENT = "content_cta.clicked";

type SidebarCtaProps = {
  title?: string;
  subtitle?: string;
  ctaText: string;
  ctaUrl: string;
  openInNewTab?: boolean;
  image?: ImageRef;
  placement?: "inline" | "sidebar";
};

export default function SidebarCta({
  title,
  subtitle,
  ctaText,
  ctaUrl,
  openInNewTab,
  image,
  placement = "sidebar",
}: SidebarCtaProps) {
  return (
    <div data-signup-placement={placement} className="blog-sidebar-cta">
      {image && (
        <Image
          className="blog-sidebar-cta__image"
          src={image.src}
          alt={image.alt}
          width={image.width ?? 0}
          height={image.height ?? 0}
          sizes="250px"
        />
      )}
      <div className="blog-sidebar-cta__content">
        {title && <h3 className="blog-sidebar-cta__title">{title}</h3>}
        {subtitle && <p className="blog-sidebar-cta__subtitle">{subtitle}</p>}
        <Link
          href={ctaUrl}
          className="blog-sidebar-cta__button"
          style={!title ? { marginTop: 10 } : undefined}
          onClick={() => {
            const properties = { placement };
            sendEvent(CONTENT_CTA_CLICKED_EVENT, { attributes: properties });
            void captureEvent(CONTENT_CTA_CLICKED_EVENT, properties);
          }}
          {...(openInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        >
          <span className="relative z-10">{ctaText}</span>
          <div className="absolute pointer-events-none inset-0 overflow-hidden rounded">
            <div className="animate-random-bubble gradient-bubble absolute" />
          </div>
        </Link>
      </div>
    </div>
  );
}
